const shopChange = {
  state: {
    shopList: {}
  },
  mutations: {
    SET_CHANGE_LIST: (state, data) => {
      state.shopList = data;
    }
  },
  actions: {
    setChangeList({ commit }, data) {
      commit("SET_CHANGE_LIST", data);
    }
  }
};
//询价审批的参数

export default shopChange;
